export default function MapleGroveMistakesSection() {
  const mistakes = [
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Apply",
      description: "Government processing times change constantly. Many Maple Grove travelers assume 6–8 weeks is safe, only to find out it is now 3–4 months. With corporate travel, medical conferences, and family trips confirmed weeks before departure, apply as soon as you confirm travel.",
    },
    {
      icon: "ri-camera-off-line",
      title: "Wrong Passport Photo",
      description: "Photos from drugstores and photo booths often get rejected for lighting, background, or expression issues. We provide exact specs so you get it right the first time — because a rejected photo can derail a last-minute Arbor Lakes business trip or family vacation.",
    },
    {
      icon: "ri-file-damage-line",
      title: "Incomplete Forms",
      description: "One missing signature or wrong date and your application gets sent back. Our checklist catches errors before submission, saving you weeks of delay that you simply cannot afford before a business trip to London or a family vacation to Italy.",
    },
    {
      icon: "ri-pen-nib-line",
      title: "Wrong Proof of Citizenship",
      description: "Not all birth certificates are accepted. Some require a long-form version. We tell you exactly which documents you need based on your situation — so your Maple Grove corporate trip or family vacation is not delayed by a preventable error.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "Missing Travel Proof for Emergency",
      description: "Regional agencies require proof of urgent travel. Without it, you are turned away. We help you prepare the right documentation before you need it — essential for last-minute business trips and family cruises.",
    },
    {
      icon: "ri-map-pin-time-line",
      title: "Not Checking Name Consistency",
      description: "Your passport name must match your driver's license and ticket exactly. Middle names, suffixes, and hyphenated names cause more rejections than you would think — and fixing them takes time Maple Grove business travelers and families simply do not have.",
    },
  ];

  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Avoid Delays</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Common Emergency &amp; Expedited Passport Application Mistakes in Maple Grove
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base">
            These mistakes cause the most delays and rejections for Maple Grove travelers. Fast Passport Center reviews your documents before submission to catch these issues — so your business conference, family cruise, or corporate trip stays on schedule.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-10">
          {mistakes.map((m, i) => (
            <div
              key={i}
              className="flex items-start gap-4 bg-[#F7F8FA] rounded-lg p-5 border border-gray-200 hover:border-[#F6C344] transition-all"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-red-50 flex-shrink-0">
                <i className={`${m.icon} text-red-400 text-lg`}></i>
              </div>
              <div>
                <h3 className="font-bold text-[#1A365D] text-sm mb-1">{m.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{m.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#1A365D] rounded-lg p-6 flex flex-col sm:flex-row items-center gap-4 text-center sm:text-left">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
            <i className="ri-shield-check-line text-[#1A365D] text-xl"></i>
          </div>
          <div className="flex-1">
            <p className="text-white font-bold text-base">We check everything for you.</p>
            <p className="text-white/70 text-sm mt-1">
              Fast Passport Center reviews your documents before submission — so you do not have to worry about these mistakes causing a delay before your next international trip from Maple Grove.
            </p>
          </div>
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap flex-shrink-0"
          >
            Get Started
          </a>
        </div>
      </div>
    </section>
  );
}